import React from "react"
import FieldDropdown from "../../../generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import {GROUP_NUMBER} from "../../../../gd/const/fields/field2-groups"
import {FieldFilterType} from "../../../proto/types"
import FieldCompanyUserRequiredReportTime_ConditionForm from "./render/condition"
import {
    FIELD_CONDITIONS_NUMBER,
    FieldNumber_hours_filterFunc
} from "../../../conditions/number"

// const debug = "FieldCompanyUserRequiredReportTime"
const debug = false

export default class FieldCompanyUserRequiredReportTime extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Required report time"
        this.typeGroup          = GROUP_NUMBER
        this.typeDescription    = "Company user required report time"
        this.filterType         = FieldFilterType.NUMBER
        this.icon               = 'i5-my-time'

        this.noValueOption      = false
        this.showMenuMore       = false

        // Mega tupaya situaciya. Nasleduetsya ot Field dropdown. No conditions ot Number
        this.conditionTypes     = FIELD_CONDITIONS_NUMBER

        this.options = _.map(gd.const.companyUser.requiredReportTime, (val:any,key:string) => ({
            label: key !== '0' ? val : 'Not required',
            value: parseInt(key)
        }))

        this.renderComponents.conditionForm = FieldCompanyUserRequiredReportTime_ConditionForm
        this.renderComponents.filterForm    = FieldCompanyUserRequiredReportTime_ConditionForm

        this.filterFunc                     = FieldNumber_hours_filterFunc

        debug && console.log(debug, 'constructor', this.options, gd.const.companyUser.requiredReportTime)
    }
}
